import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Academy = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5281 11.25H20.6752L14.1389 15.778C13.4538 16.2526 12.5462 16.2526 11.8611 15.778L4.24227 10.5L11.8611 5.22205C12.5462 4.74744 13.4538 4.74744 14.1389 5.22205L20.6752 9.75003H12.5281C12.1139 9.75003 11.7781 10.0858 11.7781 10.5C11.7781 10.9142 12.1139 11.25 12.5281 11.25ZM23.3713 9.1848C23.87 9.53023 24.0979 10.0883 24.0551 10.6282V18C24.0551 18.4142 23.7194 18.75 23.3051 18.75C22.8909 18.75 22.5551 18.4142 22.5551 18V12.3807L19.663 14.3842V18.4021C19.663 18.9126 19.5371 19.4816 19.1839 19.9759C17.7281 22.0131 15.328 22.9853 13 22.9853C10.6721 22.9853 8.27194 22.0131 6.81612 19.9759C6.46293 19.4816 6.33701 18.9126 6.33701 18.4021V14.3842L2.62872 11.8153C1.71023 11.179 1.71023 9.82108 2.62872 9.1848L10.7222 3.57801C12.0924 2.62878 13.9076 2.62878 15.2779 3.57801L23.3713 9.1848ZM8.33701 15.7697V18.4021C8.33701 18.5978 8.38594 18.7327 8.44335 18.8131C9.45608 20.2303 11.192 20.9853 13 20.9853C14.8081 20.9853 16.544 20.2303 17.5567 18.8131C17.6141 18.7327 17.663 18.5978 17.663 18.4021V15.7697L15.2779 17.4221C13.9076 18.3713 12.0924 18.3713 10.7222 17.4221L8.33701 15.7697Z"
        fill={color}
      />
    </svg>
  )
})

export default Academy
